// extracted by mini-css-extract-plugin
export default {"productCarousel":"D0-z"};